import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "var(--color-bg, #FAFAF8)",
          fontFamily: "var(--font-sans, Inter, sans-serif)",
          padding: "2rem",
          textAlign: "center",
        }}>
          <h1 style={{
            fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
            color: "var(--color-text, #1a1a2e)",
            fontWeight: 800,
            marginBottom: "0.75rem",
            letterSpacing: "-0.03em",
          }}>
            Something went wrong
          </h1>
          <p style={{
            color: "var(--color-text-secondary, #4a4e69)",
            fontSize: "1.1rem",
            maxWidth: "420px",
            lineHeight: 1.6,
            marginBottom: "1.5rem",
          }}>
            An unexpected error occurred. Please refresh the page to try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "var(--color-primary, #20B2AA)",
              color: "#fff",
              border: "none",
              borderRadius: "999px",
              padding: "0.75rem 2rem",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              transition: "transform 150ms, box-shadow 150ms",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 4px 20px rgba(32,178,170,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
